<template>
  <section class="m-card">
    <header v-if="title || $slots.actions" class="m-card__head">
      <CygnusIcon v-if="icon" :name="icon" class="m-card__icon" />
      <h3 v-if="title" class="m-card__title">{{ title }}</h3>
      <span v-if="subtitle" class="m-card__subtitle">{{ subtitle }}</span>
      <div class="m-card__actions"><slot name="actions" /></div>
    </header>
    <div class="m-card__body"><slot /></div>
  </section>
</template>

<script>
/**
 * MusubiSectionCard — a titled content card with an optional icon + an
 * `actions` slot (right-aligned). The everyday panel wrapper.
 *
 *   <MusubiSectionCard title="Lead pipeline" icon="broadcast">
 *     <template #actions><button>…</button></template>
 *     …content…
 *   </MusubiSectionCard>
 */
export default {
  name: 'MusubiSectionCard',
  props: {
    title:    { type: String, default: '' },
    subtitle: { type: String, default: '' },
    icon:     { type: String, default: '' },
  },
};
</script>

<style scoped>
.m-card {
  background: var(--m-bg-card);
  border: 1px solid var(--m-border);
  border-radius: var(--m-radius-lg);
  box-shadow: var(--m-shadow-card);
}
.m-card__head {
  display: flex; align-items: center; gap: 9px;
  padding: var(--m-space-4) var(--m-space-4) 0;
}
.m-card__icon { color: var(--m-accent); }
.m-card__title { margin: 0; font-size: var(--m-text-lg); font-weight: 700; color: var(--m-text-primary); }
.m-card__subtitle { color: var(--m-text-tertiary); font-size: 0.8rem; }
.m-card__actions { margin-left: auto; display: flex; gap: 8px; align-items: center; }
.m-card__body { padding: var(--m-space-4); }
</style>
